import slick from 'slick-carousel'

function slickSlider() {
    // Define the sliders to initialize
    const slidersToInit = [
        '#products-presentation',
        '.shop-benefits',
        '.products-overview-small',
        '.products-overview-medium',
        '.products-overview-big'
    ];

    // Add transition styles for smoother slider replacements
    slidersToInit.forEach(selector => {
        const $element = $(selector);
        if ($element.length) {
            // Add a transition class if it doesn't already have it
            if (!$element.hasClass('slider-transition')) {
                $element.addClass('slider-transition');
            }

            // Fade out before unslicking
            if ($element.hasClass('slick-initialized')) {
                $element.css('opacity', 0);

                // Wait for fade out to complete
                setTimeout(() => {
                    $element.slick('unslick');
                    initializeSlider($element);
                }, 200);
            } else {
                initializeSlider($element);
            }
        }
    });

    // Add necessary CSS for transitions
    // if (!$('#slider-transition-styles').length) {
    //     $('head').append(`
    //         <style id="slider-transition-styles">
    //             .slider-transition {
    //                 transition: opacity 0.2s ease-in-out;
    //             }
    //             .slick-slider.slick-initialized {
    //                 opacity: 1;
    //             }
    //         </style>
    //     `);
    // }
}

function initializeSlider($element) {
    const selector = $element.selector || ($element[0] ? $element[0].className : '');

    // Set initial opacity
    $element.css('opacity', 0);

    // Initialize appropriate slider based on selector
    if (selector.includes('products-presentation') || $element.is('#products-presentation')) {
        $('#products-presentation').slick({
            arrows: true,
            dots: false,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            prevArrow: "<div class='slick-prev'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 5L9 12L16 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
            nextArrow: "<div class='slick-next'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 5L16 12L9 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        arrows: false
                    }
                }, {
                    breakpoint: 577,
                    settings: {
                        variableWidth: false,
                    }
                }
            ]
        });
    } else if (selector.includes('shop-benefits') || $element.is('.shop-benefits')) {
        $('.shop-benefits').slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 4,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                    }
                }, {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    } else if (selector.includes('products-overview-small') || $element.is('.products-overview-small')) {
        $('.products-overview-small').slick({
            arrows: true,
            dots: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 4,
            prevArrow: "<div class='slick-prev'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 5L9 12L16 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
            nextArrow: "<div class='slick-next'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 5L16 12L9 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        variableWidth: true,
                        arrows: false
                    }
                }, {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    } else if (selector.includes('products-overview-medium') || $element.is('.products-overview-medium')) {
        $('.products-overview-medium').slick({
            arrows: true,
            dots: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 5,
            prevArrow: "<div class='slick-prev'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 5L9 12L16 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
            nextArrow: "<div class='slick-next'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 5L16 12L9 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>"
        });
    } else if (selector.includes('products-overview-big') || $element.is('.products-overview-big')) {
        $('.products-overview-big').slick({
            arrows: true,
            dots: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 6,
            prevArrow: "<div class='slick-prev'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 5L9 12L16 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
            nextArrow: "<div class='slick-next'><svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 5L16 12L9 19' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        variableWidth: true,
                        arrows: false
                    }
                }, {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    // Fade in after initialization
    setTimeout(() => {
        $element.css('opacity', 1);
    }, 50);
}

$(document).ready(function() {
    slickSlider();
});

document.addEventListener('livewire:initialized', function () {
    // Event listener for selectVariant
    Livewire.on('selectVariant', () => {
        slickSlider();
    });
});
